import { Component, OnInit } from '@angular/core';
import { DetailStoreService } from 'src/app/itineries/services/store/detail-store/detail-store.service';
import * as _ from 'underscore';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { Events } from 'src/app/utils/event-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { checkRole } from 'src/app/utils/utils.common';
import { SearchStoreService } from 'src/app/itineries/services/store/search-store/search-store.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { FundingsourcestoreService } from 'src/app/itineries/services/store/fundingsource-store/fundingsource-store.service';
import { LosStoreService } from 'src/app/itineries/services/store/los-store/los-store.service';
import { ServiceareaStoreService } from 'src/app/itineries/services/store/servicearea-store/servicearea-store.service';
import { SpaceTypeStoreService } from 'src/app/itineries/services/store/spacetype-store/spacetype-store.service';
import { TripStoreService } from 'src/app/itineries/services/store/trip-store/trip-store.service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { BreakModalService } from 'src/app/modals/break-modal/break-modal-service/break-modal.service';
import { WaypointsStoreService } from 'src/app/itineries/services/store/waypoint-store/waypoints-store.service';
enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}

@Component({
  selector: 'app-driverload',
  templateUrl: './driverload.component.html',
  styleUrls: ['./driverload.component.css']
})
export class DriverloadComponent implements OnInit {

  todayDate: any;
  selectedDriverId: any;
  allTrips: any[];
  nonSuggestedTrips: any[];
  nonSuggestedMainTrips: any[];
  driverTrips: any[];
  tripsPickupPoints: any[];
  driverMainTrips: any[];
  waypoints: any[];
  selectedTripsDriver: null;
  selectedServiceArea: any;
  isAdvanceMode: boolean;
  user: any;
  timeZone: any;
  preAssistList: any;
  drivers: any;
  filteredDrivers: any;
  preDriver: any;
  violations: any;
  preSpaceTypes: any;
  selectedTimeLines: any;
  isDragging: boolean;
  preCooperates: any;
  preLevelOfServices: any;
  stationManagerList: any;
  preStaffList: any;
  driverServiceAreas: any;
  preServiceAreas: any;
  selectedServiceAreas: any;
  isResizing: boolean;
  nearbyDrivers: any;
  selectedTripETA: any;
  selectedStationManager: any;
  isAllowDriversOnMap: boolean;
  breakModalObj: { driver: any; break: any; date: any; };
  columnsSortState: any;
  selectedEditTrip: any;
  partialEditModalObj: any;
  search;

  constructor(
    private detailStore: DetailStoreService,
    private assignTripService: AssigTripsService,
    private searchStore: SearchStoreService,
    private assistService: AssistService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private driverService: DriversService,
    private fundingSourceStore: FundingsourcestoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private serviceAreasStore: ServiceareaStoreService,
    private losStore: LosStoreService,
    private tripStore: TripStoreService,
    private staffService: StaffService,
    private breakService:BreakModalService,
    private waypointStore: WaypointsStoreService
  ) { }


  ngOnInit() {
    window.addEventListener("keyup", this.initializeSpecialController);
    this.getUser();
    this.listenSocket();
  }


  initializeSpecialController = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isAdvanceMode = !this.isAdvanceMode;
    }
  };


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.todayDate = moment.tz(this.todayDate, this.timeZone).startOf('day').toISOString();
          this.prepareData();
        }


      });
  }

  prepareData(){
    this.getDriverEmit();
    this.getAssist();
    this.getServiceAreas();
    this.getStaffList();
    this.getSpaceTypes();
    this.getLevelOfService();
    this.getCorporate();

    this.detailStore.state$.subscribe((state: any) => {
      if (state && state.map && state.map.key) {
        this.selectedDriverId = state.map.key
        this.getTripsEmit();
      }

    })
    this.searchStore.state$.subscribe((state) => {
      if (state && state.date) {
        this.todayDate = state.date[0];
        this.selectedDriverId = null;

        this.getTripsEmit();
      }
    })
  }

  getAssist() {
    this.assistService.getAllAssists()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getDriverList(apiResponse) {
    this.drivers = apiResponse;
    this.filteredDrivers = apiResponse;
    this.preDriver = apiResponse.reduce((obj, item) => (obj[item._id] = item, obj), {});
    this.selectedDriverId = '';
  }

  getTripsEmit() {
    this.tripStore.state$.subscribe((data) => {
      this.getAllTrips(data.list)
    })
  }

  getViolationData(apiResponse) {
    this.violations = apiResponse;
  }


  getAllTrips(apiResponse) {
    this.allTrips = [];
    this.nonSuggestedTrips = [];
    this.nonSuggestedMainTrips = [];
    this.driverTrips = [];
    this.tripsPickupPoints = [];
    this.driverMainTrips = [];
    this.waypoints = [];
    this.selectedTripsDriver = null;

    if (apiResponse) {
      this.allTrips = apiResponse;
      this.filterTrips();
    }
  }

  filterTrips() {
    this.nonSuggestedTrips = [];
    this.driverTrips = [];
    this.driverMainTrips = [];
    this.nonSuggestedMainTrips = [];


    // Separate trips assigned to selected driver and unassigned trips
    this.allTrips.forEach(trip => {
      // Skip cancelled trips without job
      if (trip.status === 'cancelled' && !trip.job) {
        return;
      }

      // If trip is assigned to selected driver
      if (
        (trip.driver && this.selectedDriverId  && (
          (typeof trip.driver === 'string' && trip.driver === this.selectedDriverId) ||
          (typeof trip.driver === 'object' && trip.driver._id === this.selectedDriverId)
        ))
      ) {
        this.driverMainTrips.push(trip);
      } else if (!trip.driver) {
        // Unassigned trips
        this.nonSuggestedMainTrips.push(trip);
      }
        });

    this.filterTripsByModel();
  }

  filterTripsByModel() {
    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();
  }

  async filterDriverMainTrips() {
    this.driverTrips = this.driverMainTrips;

    this.driverTrips.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));
    if(!this.selectedDriverId || this.selectedDriverId === 'no_driver' ) return;
    const params = {
      todayDate: this.todayDate,
      user: this.user,
      selectedDriverId: this.selectedDriverId,
      drivers: this.drivers,
      violations: this.violations,
      preSpaceTypes: this.preSpaceTypes,
      selectedTimeLines: this.selectedTimeLines,
      driverTrips: this.driverTrips,
      selectedTripsDriver: this.selectedTripsDriver,
    }
    this.tripsPickupPoints = await this.assignTripService.setupTripsByPickup(params);
    this.detailStore.setEntitiesNew({key: null, value: this.tripsPickupPoints});
  }

  filterNonSuggestedMainTrips() {
    this.nonSuggestedTrips = this.nonSuggestedMainTrips;
    this.nonSuggestedTrips.sort((a, b) => <any>moment(a.scheduleTime) - <any>moment(b.scheduleTime));

  }



  ngOnDestroy(): void {
    window.removeEventListener("keyup", this.initializeSpecialController);
  }

  getUTCTime(travel) {
    return moment(travel).format("HH:mm:ss")
  }

  getFullUTCTime(travel) {
    return moment(travel).format("MM/DD/YYYY")
  }

  getTotalMiles() {
    let totalMiles = 0;
    for (let trip of this.driverTrips) {
      totalMiles = totalMiles + trip.milage;
    }
    return totalMiles.toFixed(2);
  }

  getDriverFromID() {
    const findDriver = this.drivers.find(driver => driver._id === this.selectedDriverId);
    return findDriver;
  }

  removeFromBucket(assign) {
    if (assign && assign.farmout) {
      return;
    }
    assign.status = 'unassigned';

    let indexTwo = this.driverMainTrips.findIndex(t => t._id === assign._id);
    this.driverTrips.splice(indexTwo, 1);

    this.nonSuggestedMainTrips.push(assign);

    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();

    this.processBucket({
      _id: assign._id,
      status: 'unassigned',
      jobStatus: 'pending'
    })
  };


  processBucket(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.filterDriverMainTrips();
          this.filterNonSuggestedMainTrips();
          const findTripIndex = this.allTrips.findIndex(t => t._id === payload._id);
          if (findTripIndex >= 0) {
            this.allTrips[findTripIndex] = data;
          } else {
            this.allTrips.push(data);
          }
          this.tripStore.setEntities(this.allTrips);

        } else if (data) {
          sweetAlert('Error', data, 'warning', 'OK');
        }
      });
  }


  toggleSelection(item: any): void {
    if (item.polyline) {
      item.polyline = false
    } else {
      item.polyline = true
    }
    this.waypoints = [];
    for (let point of this.tripsPickupPoints) {
      if (point.polyline) {
        this.waypoints.push(
          { stopover: false, location: { lat: point.isPickup ? point.jobOriginLatitude : point.jobDestinationLatitude, lng: point.isPickup ? point.jobOriginLongitude : point.jobDestinationLongitude } }
        )
      }
    }
    this.waypointStore.setEntitiesNew({ key: null, value: this.waypoints });
  }

  onMouseDown(item: any) {
    this.isDragging = true;
    this.toggleSelection(item);
  }

  onMouseUp() {
    this.isDragging = false;
  }

  onMouseOver(item: any) {
    if (this.isDragging) {
      this.toggleSelection(item);
    }
  }

  getCorporate() {
    this.fundingSourceStore.state$.subscribe(data=>{
      if(data){
        this.preCooperates = data.map;
      }
    })

  }


  getLevelOfService() {
    this.losStore.state$.subscribe(data => {
      if (data) {
        this.preLevelOfServices = data.map;
      }
    })
  }

  getSpaceTypes() {
    this.spaceTypeStore.state$.subscribe(data => {
      if (data) {
        this.preSpaceTypes = data.map;
      }
    })
  }

  getStaffList() {
    let queryParams = {
      status: 'active'
    };
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          this.stationManagerList = data.filter(staff => ["mdispatcher", "mcallcenter"].includes(staff.roles));;

        }
      });
  }

  getServiceAreas() {
    this.serviceAreasStore.state$.subscribe(data => {
      if (data) {
        this.driverServiceAreas = data.list;
        this.preServiceAreas = data.map;
      }
    })
    this.getDriverEmit();
  }

  getDriverEmit() {
    let endPoint = '';

    if (this.selectedServiceAreas && this.selectedServiceAreas.length) {
      endPoint = '?serviceAreas=' + this.selectedServiceAreas.toString();
    }

    const data = {
      endPoint: endPoint,
      userId: this.user._id
    }
    this.driverService
      .getDrivers(data.userId, data.endPoint, true)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.getDriverList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  roundTwoDigit(value: any) {
    let numberValues;
    if (typeof value !== 'number') {
      numberValues = parseFloat(value).toFixed(2);
    } else {
      numberValues = value.toFixed(2);
    }

    return numberValues;
  }

  getMarkeBall(assign, isPickup) {

    let icon = isPickup ? 'assets/images/map/origin_circle.png' : 'assets/images/map/destination_circle.png'
    if (assign.jobStatus === 'finished' || assign.jobStatus === 'cancelled') {
      icon = 'assets/images/map/finished_circle.png';
    }

    return icon;
  }

  horizontalResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarLeft = document.getElementById('horizontal-sidebar-left');
    const sidebarRight = document.getElementById('horizontal-sidebar-right');

    if (sidebarLeft && sidebarRight) {
      const initialWidthL = sidebarLeft.offsetWidth;
      const initialWidthR = sidebarRight.offsetWidth;
      const startX = event.clientX;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientX - startX;
          const newWidthL = initialWidthL + offsetX;
          const newWidthR = initialWidthR - offsetX;

          if (newWidthL >= 0 && newWidthR >= 0) {
            sidebarLeft.style.width = newWidthL + 'px';
            sidebarRight.style.width = newWidthR + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }

  startResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarTop = document.getElementById('resizable-sidebar-top');
    const sidebarBottom = document.getElementById('resizable-sidebar-bottom');

    if (sidebarTop && sidebarBottom) {
      const initialHeightT = sidebarTop.offsetHeight;
      const initialHeightB = sidebarBottom.offsetHeight;
      const startX = event.clientY;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientY - startX;
          const newHeightT = initialHeightT + offsetX;
          const newHeightB = initialHeightB - offsetX;

          if (newHeightT >= 0 && newHeightB >= 0) {
            sidebarTop.style.height = newHeightT + 'px';
            sidebarBottom.style.height = newHeightB + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }


  onClearCooperate() { }

  compareDriver(driver) {
    this.selectedDriverId = driver._id;
    this.getTripsEmit()
  }

  getNearbyDriver(trip) {
    let data: any = {}
    // if (this.componentType !== 'Multiple Assign') {
    data = {
      jobOriginLatitude: trip.jobOriginLatitude,
      jobOriginLongitude: trip.jobOriginLongitude,
      fundingSource: trip.cooperate,
      spaceType: trip.spaceType,
      scheduleTime: trip.scheduleTime,
      isNearBy: true,
      loadTime: this.preSpaceTypes[trip.spaceType].loadTime,
      unloadTime: this.preSpaceTypes[trip.spaceType].unloadTime,
      milage: trip.milage,
      jobDestinationLatitude: trip.jobDestinationLatitude,
      jobDestinationLongitude: trip.jobDestinationLongitude,
      appointmentTime: trip.appointmentTime,

    };

    if (trip.serviceArea) {
      data.serviceArea = trip.serviceArea
    }
    // }


    this.getNearbyDriversRes(data);
  }

  getNearbyDriversRes(payload) {
    this.driverService
      .getNearbyDrivers(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.nearbyDrivers = data.drivers;

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  timeValidation(trip) {
    const params = {
      trip,
      violations: this.violations,
      timeZone: this.timeZone
    }
    return this.assignTripService.timeValidation(params);
  }

  setAllDriverServicesAreas() {
    for (let driverServiceArea of this.driverServiceAreas) {
      this.selectedServiceAreas.push(driverServiceArea._id);
    }
  }

  checkDriverFleetSpacetype(trip) {
    let isExist = false;
    if (trip.spaceType && this.selectedDriverId && this.preDriver[this.selectedDriverId].fleet && this.preDriver[this.selectedDriverId].fleet.capacities && this.preDriver[this.selectedDriverId].fleet.capacities.length) {
      isExist = this.preDriver[this.selectedDriverId].fleet.capacities.some(capacity => capacity.spaceType === trip.spaceType);
    }
    return isExist;
  }

  listenSocket() {
    this.socketService
      .addListener(Events.DROP_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data.success) {
          // this.getTripsEmit();
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  getMiles(trip) {
    this.selectedTripETA = trip;
    if (!trip.jobOriginAddress || !trip.jobDestinationAddress) {
      sweetAlert('Alert', 'Please select Pickup & Drop Off address', 'warning', 'OK')
      return;
    }
    this.setUpSocketListener();
    let data = {
      origin: trip.jobOriginLatitude + ',' + trip.jobOriginLongitude,
      destination: trip.jobDestinationLatitude + ',' + trip.jobDestinationLongitude
    };
    this.socketService.emit(Events.GET_MILES_CALL, data);
  }

  setUpSocketListener() {
    this.socketService.addListener(Events.GET_MILES_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.selectedTripETA.googleMilage = data.message;
        this.socketService.removeListener(Events.GET_MILES_CALL);
      });
  }

  meterToMiles(distance) {
    return distance.toFixed(2);
    // return (distance / 1609).toFixed(2);
  }

  getTripDisplayName(assign, first, last) {
    let textLable = '';
    if (assign.priorityClient && assign.priorityClient.displayName) {
      textLable = assign.priorityClient.displayName.toUpperCase();
      if (assign.isPickup) {
        if (assign.isBreakTrip) {
          textLable += " - Start."
        } else {
          textLable += " - Pickup Appt."
        }
      } else if (assign.isDropOff) {
        if (assign.isBreakTrip) {
          textLable += " - End."
        } else {
          textLable += " - Dropoff Appt."
        }
      }
    } else if (first) {
      textLable = "Pull - Out.";
    } else if (last) {
      textLable = "Shift - End.";
    }

    return textLable;
  }


  isStringExist(substrings, str) {
    if (substrings.some((v) => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }


  onEditTrip(trip, type) {
    if (trip && trip.farmout) {
      return;
    }
    this.selectedEditTrip = trip;
    this.selectedEditTrip.isFromNonSuggested = type;
  }

  setPartialEditModal(trip) {
    if (trip && trip.farmout) {
      return;
    }
    this.partialEditModalObj = trip;
  }

  dropTrip(trip) {
    if (trip && trip.farmout) {
      return;
    }
    sweetAlert(
      "Alert",
      "Are you sure you want to drop this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        let params = {
          assignId: trip._id,
          changeReason: "Will Do Later",
          driverId: this.selectedDriverId,
          company: { _id: this.user._id, displayName: this.user.displayName },
        };
        this.socketService.emit(Events.DROP_TRIP, params);
      }
    });
  }


  async sendToSpecificBucket(assign) {
    if (assign && assign.farmout) {
      return;
    }
    assign.status = 'offered';
    let findDriver = await this.drivers.find(d => d._id === this.selectedDriverId);
    this.driverMainTrips.push(assign);


    let index = await this.nonSuggestedMainTrips.findIndex(t => t._id === assign._id);
    this.nonSuggestedMainTrips.splice(index, 1);

    this.filterDriverMainTrips();
    this.filterNonSuggestedMainTrips();

    this.processBucket({
      _id: assign._id,
      status: 'offered',
      jobStatus: 'offered',
      driver: findDriver._id
    });
  };

  onEditTripUpdate(evt) {
    if (this.selectedEditTrip && evt) {
      if (this.selectedEditTrip.isFromNonSuggested) {
        const index = this.nonSuggestedTrips.findIndex(t => t._id === evt._id);
        this.nonSuggestedTrips[index] = { ...this.nonSuggestedTrips[index], ...evt };
      } else {
        const index = this.driverMainTrips.findIndex(t => t._id === evt._id);
        this.driverMainTrips[index] = { ...this.driverMainTrips[index], ...evt };
        this.filterDriverMainTrips();
      }

      // Update trip in allTrips and TripStore
      const allTripsIndex = this.allTrips.findIndex(t => t._id === evt._id);
      if (allTripsIndex !== -1) {
        this.allTrips[allTripsIndex] = { ...this.allTrips[allTripsIndex], ...evt };
      }
      this.tripStore.setEntities(this.allTrips);

      this.selectedEditTrip = null;
    }
  }

  updateTripNotes(evt) {

    const index = this.driverMainTrips.findIndex(t => t._id === evt._id);
    this.driverMainTrips[index] = { ...this.driverMainTrips[index], ...evt }
    this.filterDriverMainTrips();
    // Update trip in allTrips and TripStore
    const allTripsIndex = this.allTrips.findIndex(t => t._id === evt._id);
    if (allTripsIndex !== -1) {
      this.allTrips[allTripsIndex] = { ...this.allTrips[allTripsIndex], ...evt };
    }
    this.tripStore.setEntities(this.allTrips);
    this.partialEditModalObj = null;
  }

}







